export interface IWindowExtensionTagManagerEvents extends Window {
  /** The TagManagerEvents object that the Window interface is being extended with */
  dataLayer: any
  liveSearch: any
}

// Here we are extending the Window interface with the TagManagerEvents interface.
declare let window: IWindowExtensionTagManagerEvents

const TagManager = {
  fireSearchEvent(value) {
    if (window.dataLayer === undefined || value.length <= 0) {
      return
    }

    const isAllowed = window.dataLayer.some((x) => x.cookiehub_analytics)
    if (!isAllowed) {
      return
    }

    window.dataLayer.push({
      event: 'search_event',
      keyword: value,
    })
  },
}

export default TagManager
